const maxLatinError = 'errors.formFields.maxLatin';

const maxLatinChars = (fieldName, max) => (value) => {
  if (!value) return;
  
  const errorKey = fieldName ? `${maxLatinError}.${fieldName}` : maxLatinError;
  
  return value.replace(/[^[a-zA-Z]/g, '').length > max ? [errorKey, max] : undefined;
};

export default maxLatinChars;
